import React, {useEffect, useRef} from 'react'
import {useGigyaModal} from '../../context/gigya-modal'
import GigyaModal from './gigya-modal'
import {Portal, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useGigya} from '../../context/gigya'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import useUtils from '../../custom-hooks/use-utils-helper'
import {useLocation} from 'react-router-dom'
import {useWishList} from '../../hooks/use-wish-list'
import {useCurrentBasket} from '@salesforce/retail-react-app/app/hooks/use-current-basket'
import {setCustomData} from '../../utils/gigya'

const GlobalGigyaModal = () => {
    const {isOpen, isNotifyMe, closeModal, callback} = useGigyaModal()
    const {gigyaObject, gigyaLocale} = useGigya()
    const {locale} = useMultiSite()
    const navigate = useNavigation()
    const {data: customer} = useCurrentCustomer()
    const hasLoggedIn = useRef(false)
    const location = useLocation()
    const {isWishlistPage} = useUtils().currentPage(location.pathname)

    const {data: basket} = useCurrentBasket()
    const {data: wishListData} = useWishList()

    const stylesLogin = useMultiStyleConfig('Login')

    // Handle Gigya modal: clear container on close, inject form on open
    useEffect(() => {
        if (!isOpen) {
            const container = document.getElementById('gigya-login-popup-screen-container')
            if (container) {
                container.innerHTML = ''
            }
            return
        }

        if (!gigyaObject) return

        const timer = setTimeout(() => {
            gigyaObject?.accounts.showScreenSet({
                screenSet: 'Default-RegistrationLogin',
                startScreen: 'gigya-login-popup-screen',
                containerID: 'gigya-login-popup-screen-container',
                lang: gigyaLocale,
                deviceType: 'desktop',
                onBeforeScreenLoad: () => {},
                onAfterScreenLoad: () => {
                    const container = document.getElementById('gigya-login-popup-screen-container')
                    if (container) {
                        void container.offsetHeight // Force reflow to apply CSS
                    }

                    const element = document.querySelector(
                        '#gigya-login-popup-screen-container .with-social-login .gigya-composite-control-link',
                    )
                    if (element) {
                        element.href = `/${locale?.alias}/registration`
                    }
                },
                onBeforeValidation: () => {},
                onBeforeSubmit: () => {
                    gigyaObject && gigyaObject.accounts && gigyaObject.accounts.logout()
                },
                onSubmit: (e) => setCustomData(e),
                onAfterSubmit: (response) => {
                    if (
                        response &&
                        (response.response.status === 'OK' || response.response.statusCode === 200)
                    ) {
                        closeModal()
                        hasLoggedIn.current = true

                        if (isNotifyMe && !isWishlistPage) {
                            localStorage.setItem('preventGigyaDefaultRedirect', 'true')
                        } else if (!isNotifyMe || isWishlistPage) {
                            localStorage.setItem('preventGigyaDefaultRedirect', 'true')
                            setTimeout(() => {
                                navigate('/account/wishlist')
                            }, 1000)
                        }

                        localStorage.setItem('guestBasket', JSON.stringify(basket))
                        localStorage.setItem('guestWishList', JSON.stringify(wishListData))
                    }
                },
                onError: () => {},
                onFieldChanged: () => {},
            })
        }, 50)

        return () => clearTimeout(timer)
    }, [
        gigyaObject,
        isOpen,
        isNotifyMe,
        locale,
        closeModal,
        isWishlistPage,
        navigate,
        basket,
        wishListData,
        gigyaLocale,
    ])

    useEffect(() => {
        if (hasLoggedIn.current && customer?.c_gigyaId) {
            localStorage.setItem('DL-NotifyMe-Customer', JSON.stringify(customer))

            callback && callback()

            hasLoggedIn.current = false
        }
    }, [customer])

    return (
        <Portal>
            <GigyaModal
                onClose={closeModal}
                isOpen={isOpen}
                wishlist={true}
                isNotifyMe={isNotifyMe}
                variant="wishlist"
                __css={stylesLogin}
            >
                <div id="gigya-login-popup-screen-container"></div>
            </GigyaModal>
        </Portal>
    )
}

export default GlobalGigyaModal
